// Foundry calendar import/export types (P0-13 stage 2, adopted by 1.K-1 stage 1,
// deliverable 1). The definition types are 1.0b's frozen calendar contract,
// re-exported under the names this entry has always exported, so there is one
// definition type for the engine, the import and export, storage and the
// calendar editor. Only the raw Foundry file schema below is local. It is
// built with the configured (jitless) `z` of `@codex/contracts`, never with
// `zod` directly (orchestrator ruling 3).
import { z, } from '@codex/contracts';
// --- The raw Foundry `CalendarConfig` shape (plus the app's non-core id/system/moons). ---
// Every object level uses `.passthrough()` so unrecognized keys survive zod's
// parse; `importFoundry` reads extras from the original `json`, not from this
// parsed value, but passthrough keeps validation from rejecting a file that
// merely carries an extra key.
const monthSchema = z
    .object({
    name: z.string(),
    abbreviation: z.string().nullable().optional(),
    ordinal: z.number(),
    days: z.number(),
    startingWeekday: z.number().nullable().optional(),
    leapDays: z.number().nullable().optional(),
    intercalary: z.boolean().nullable().optional(),
    dayOffset: z.number().nullable().optional(),
})
    .passthrough();
const weekdaySchema = z
    .object({
    name: z.string(),
    abbreviation: z.string().nullable().optional(),
    ordinal: z.number(),
    isRestDay: z.boolean().nullable().optional(),
})
    .passthrough();
const seasonSchema = z
    .object({
    name: z.string(),
    abbreviation: z.string().nullable().optional(),
    monthStart: z.number().nullable().optional(),
    monthEnd: z.number().nullable().optional(),
    dayStart: z.number(),
    dayEnd: z.number(),
})
    .passthrough();
const moonSchema = z
    .object({
    name: z.string(),
    cycleLength: z.number(),
    offset: z.number(),
})
    .passthrough();
export const rawFoundryCalendarSchema = z
    .object({
    name: z.string(),
    description: z.string().optional(),
    years: z
        .object({
        yearZero: z.number(),
        firstWeekday: z.number(),
        leapYear: z
            .object({ leapStart: z.number(), leapInterval: z.number() })
            .passthrough()
            .nullable()
            .optional(),
    })
        .passthrough(),
    months: z.object({ values: z.array(monthSchema) }).passthrough(),
    days: z
        .object({
        values: z.array(weekdaySchema),
        daysPerYear: z.number(),
        hoursPerDay: z.number(),
        minutesPerHour: z.number(),
        secondsPerMinute: z.number(),
    })
        .passthrough(),
    seasons: z
        .object({ values: z.array(seasonSchema) })
        .passthrough()
        .optional(),
    moons: z
        .object({ values: z.array(moonSchema) })
        .passthrough()
        .optional(),
})
    .passthrough();
//# sourceMappingURL=types.js.map